import { getFromStorage } from "../../utils/storageUtils";
import { NotificationsIdDto } from "../../dtos/notifications/MarkAsReadDto";
import instance, { del, get, post } from "../../utils/BaseService";
import { CreateNotificationDto } from "../../dtos/notifications/CreateNotificationDto";
import { SearchNotificationDto } from "../../dtos/notifications/searchNotification";

export async function getUserNotifications(dispatch: any) {
  return await get(dispatch, "/notification/getUserNotifications", null);
}

export async function createNotification(dispatch: any, input: CreateNotificationDto): Promise<{
  success: boolean;
  message: string;
}> {
    return await post(dispatch, '/notification/createNotification', input);
 };
export async function existingNotificationCount(dispatch: any, input: SearchNotificationDto){
    return await post(dispatch, '/notification/existCount', input);
 };
export async function markAsRead(dispatch: any,input:NotificationsIdDto) {
  return await post(dispatch, "/notification/markAsRead",input);
}
export async function getNotificationsStatusCount(dispatch: any,input:{status:string}) {
  return await get(dispatch, "/notification/count",input);
}
export async function getUnreadNotifications(dispatch: any,input:{userId:string}) {
  return await get(dispatch, "/notification/getUnreadNotifications",input);
}
export async function markAllNotificationsAsRead() {
  const header = {
  access_token: localStorage.getItem("token"),
  tenantId: localStorage.getItem("tenantId"),
};
  const response = await instance.post("/notification/markAllAsRead", {
    headers: {
      ...header,
      'Content-Type': 'application/json'
    }
  });
  return response.data;
}
export async function deleteNotifications(dispatch: any,input:{notificationIds:number[]}) {
  const header = {
  access_token: localStorage.getItem("token"),
  tenantId: localStorage.getItem("tenantId"),
};
  const response = await instance.delete("/notification/deleteNotifications", {
    data: input, // Note: For DELETE requests with body, axios uses 'data' property
    headers: {
      ...header,
      'Content-Type': 'application/json'
    }
  });
  return response.data;
}
